import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchVendors } from './api';

/** Tenant-wide — see queryKeys.ts's procurement comment. */
export function useVendors() {
  return useQuery({ queryKey: keys.procurement.vendors(), queryFn: fetchVendors });
}
